import { render, staticRenderFns } from "./CamaraHistorico.vue?vue&type=template&id=30101cd7&scoped=true&"
import script from "./CamaraHistorico.vue?vue&type=script&lang=ts&"
export * from "./CamaraHistorico.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraHistorico.vue?vue&type=style&index=0&id=30101cd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30101cd7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('30101cd7', component.options)
    } else {
      api.reload('30101cd7', component.options)
    }
    module.hot.accept("./CamaraHistorico.vue?vue&type=template&id=30101cd7&scoped=true&", function () {
      api.rerender('30101cd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/Historico/CamaraHistorico.vue"
export default component.exports